import { type Common } from './common.js';
import type * as RpaJob from './models/rpaJob.js';

export class API {
  common: Common;
  baseEndpoint = '/rpa-jobs';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(query?: RpaJob.FindAllOptions): Promise<RpaJob.RpaJob[]> {
    const url = this.common.constructPath(this.baseEndpoint, query);
    const { rpaJobs } = await this.common.getJSON(url);
    return rpaJobs;
  }
}
